import { render } from "./UserMasterView.vue?vue&type=template&id=6e248e56"
import script from "./UserMasterView.vue?vue&type=script&lang=js"
export * from "./UserMasterView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__